import { COOKIE } from "@/constants/Cookie";

export function isSessionExpired(createdAt: string): boolean {
	const expiration = new Date(createdAt).getTime() + COOKIE.MAX_AGE * 1000;
	return Date.now() >= expiration;
}
